import { useEffect, useRef } from "react";
import { toast } from "react-toastify";
import { CheckCircle2, XCircle, Sparkles } from "lucide-react";
import "react-toastify/dist/ReactToastify.css";

const Toaster = ({ message }) => {
  const activeMessageRef = useRef(null);

  useEffect(() => {
    if (!message?.error && !message?.success) return;

    const currentMsg = message.error || message.success;

    if (activeMessageRef.current === currentMsg) return;

    activeMessageRef.current = currentMsg;

    const options = {
      position: "top-right",
      autoClose: 3000,
      hideProgressBar: true,
      closeButton: false,
      pauseOnHover: true,
      className: "droppie-toast",
      bodyClassName: "droppie-toast-body",
      onClose: () => {
        activeMessageRef.current = null;
      },
    };

    if (message.success) {
      toast(
        <div className="droppie-notification success">
          <div className="droppie-status">
            <span className="status-dot" />
            SUCCESS
          </div>

          <div className="droppie-message">{message.success}</div>
        </div>,
        {
          ...options,
          className: "droppie-toast",
        },
      );
    }

    if (message.error) {
      toast(
        <div className="droppie-notification error">
          <div className="droppie-status">
            <span className="status-dot" />
            ERROR
          </div>

          <div className="droppie-message">{message.error}</div>
        </div>,
        {
          ...options,
          className: "droppie-toast",
        },
      );
    }
  }, [message]);

  return null;
};

export default Toaster;
